import React from 'react';
import { Filter } from 'lucide-react';
import { EventPriority } from '../../types/calendar';
import { useDeals } from '../../store/DealsContext';

interface EventFiltersProps {
  selectedDeal: string;
  selectedPriority: EventPriority | '';
  onDealChange: (dealId: string) => void;
  onPriorityChange: (priority: EventPriority | '') => void;
}

export default function EventFilters({
  selectedDeal,
  selectedPriority,
  onDealChange,
  onPriorityChange
}: EventFiltersProps) {
  const { deals } = useDeals();

  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-2">
        <Filter className="w-5 h-5 text-gray-400" />
        <select
          value={selectedDeal}
          onChange={(e) => onDealChange(e.target.value)}
          className="pl-3 pr-10 py-2 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">All Deals</option>
          {deals.map((deal) => (
            <option key={deal.id} value={deal.id}>{deal.name}</option>
          ))}
        </select>

        <select
          value={selectedPriority}
          onChange={(e) => onPriorityChange(e.target.value as EventPriority | '')}
          className="pl-3 pr-10 py-2 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">All Priorities</option>
          <option value="high">High Priority</option>
          <option value="medium">Medium Priority</option>
          <option value="low">Low Priority</option>
        </select>
      </div>
    </div>
  );
}